import { render } from "./EmployeeJob.vue?vue&type=template&id=5a07b07f&scoped=true"
import script from "./EmployeeJob.vue?vue&type=script&lang=js"
export * from "./EmployeeJob.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=5a07b07f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a07b07f"]])

export default __exports__